import { BaseConfig } from "./base-config";

const generateProductionConfig = () =>
    new BaseConfig({
        firebaseConfig: {
            apiKey: "AIzaSyC6VBQxT70j5dbDmqowTyGMi2kL6JPP-9w",
            authDomain: "partner-portal-434018.firebaseapp.com",
            projectId: "partner-portal-434018",
            storageBucket: "partner-portal-434018.firebasestorage.app",
            messagingSenderId: "780532198083",
            appId: "1:780532198083:web:59b60d40deb380a4e91076",
        },
        jobPositionEmailRecipientLimit: 5,
        enableNpsModal: true,
        applicantMangerExcludedCustomerIds: [
            72, // Test Account
            118, // Stahlhart Recruiting (Internal)
        ],
        googleMapsClientApiKey: "AIzaSyCf9wWRQkauzpjE9ht78YKISRnLbaRwWZ4",
        defaultApplicantManagerFirebaseUids: ["pBrt7tNfKFcVxpRhidtxUWdwUDl1"],
    });

export { generateProductionConfig };
